import React from 'react'

import get from 'lodash/get'

import API from '../../../utils/http/api'
import { transformCareersData } from '../../resumesearch/dataTransformation'
import { useQuery } from '../hooks/useQuery'
import fullstory from '../../constants/fullstory';
import sendFullStoryEvent from '../../analyticsHelpers/sendFullStoryEvent';

const withCareers = BaseComponent => props => {
  const operation = 'careers'
  const defaultVariables = {
    exactMatch: { value: true, required: true },
    jobTitles: {
      value: ['Software Engineer'],
      required: true,
      type: 'String',
      list: true,
      name: 'jobTitles',
    },
    companies: {
      value: [''],
      type: 'String',
      list: true,
      name: 'companies',
    },
    states: {
      value: [''],
      type: 'String',
      list: true,
      name: 'states',
    },
  }

  const { data, refetch, loading, error, setData } = useQuery(operation, defaultVariables, {
    lazy: true,
  })

  const careersData = get(data, 'results')
  const docCount = get(data, 'doc_count', 0)

  const {
    gaugeMajorData,
    gaugeAdvancedData,
    salaryDistribution,
    gaugeBachelorPercentage,
    gaugeMajorPercentage,
    commonMajorName,
    salaryInsight,
    educationInsight,
  } = transformCareersData(careersData)

  const getCareersData = async searchFormValues => {
    const { search_query, company, state, exact_match } = searchFormValues
    if (!search_query) return
    const jobTitles = search_query ? { jobTitles: [search_query] } : {}
    const companies = company ? { companies: [company] } : {}
    const states = state
    const variables = {
      ...jobTitles,
      ...companies,
      states,
      exact_match,
    }

    sendFullStoryEvent(fullstory.eventNames.careerSearch, {
      searchQuery_strs: variables.jobTitles,
      company_strs: variables.companies,
      state_strs: variables.states,
      exactMatch_bool: variables.exact_match,
    })

    await API.post('/resumes/career/history', searchFormValues)

    refetch(variables)
  }

  return (
    <BaseComponent
      {...props}
      careersData={careersData}
      getCareersData={getCareersData}
      loadingCareersData={loading}
      docCount={docCount}
      gaugeMajorData={gaugeMajorData}
      gaugeAdvancedData={gaugeAdvancedData}
      salaryDistribution={salaryDistribution}
      gaugeBachelorPercentage={gaugeBachelorPercentage}
      gaugeMajorPercentage={gaugeMajorPercentage}
      commonMajorName={commonMajorName}
      salaryInsight={salaryInsight}
      educationInsight={educationInsight}
      searchError={error}
      setCareersData={setData}
    />
  )
}

export default withCareers



// WEBPACK FOOTER //
// ./src/utils/graphql/hocs/withCareers.js